export default __webpack_public_path__ + "static/media/studio.2dbc1c33.svg";